import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';

@Injectable()
export class ValidatorService {

  public isRequire = (control: FormControl) => {
    return this.check_if_is_require(control.value) ? null : {
      required: false
    };
  }

  public isInteger = (control: FormControl) => {
    return this.check_if_is_integer(control.value) ? null : {
      isinteger: false
    };
  }

  public isNumeric = (control: FormControl) => {
    return this.check_if_is_numeric(control.value) ? null : {
      isnumeric: false
    };
  }

  public isTcnumber = (control: FormControl) => {
    return this.check_if_is_tc_number(control.value) ? null : {
      valid: false,
      invalid: true,
      istcnumber: false
    };
  }

  public isSiretnumber = (control: FormControl) => {
    return this.check_if_is_siret_number(control.value) ? null : {
      valid: false,
      invalid: true,
      issiretnumber: false
    };
  }

  public isAwbnumber = (control: FormControl) => {
    return this.check_if_is_awb_number(control.value) ? null : {
      valid: false,
      invalid: true,
      isawbnumber: false
    };
  }

  check_if_is_require(value: any) {
    if (value > 111) {
      return true;
    } else {
      return false;
    }
  }

  check_if_is_numeric(value: any) {
    if (!isNaN(value)) {
      return true;
    } else {
      return false;
    }
  }

  check_if_is_integer(value: any) {
    if ((parseFloat(value) == parseInt(value)) && !isNaN(value)) {
      return true;
    } else {
      return false;
    }
  }

  check_if_is_awb_number(value: any) {
    if (!value || value == '') {
      return true;
    }
    123 - 12345675;
    if (value.length != 12) {
      return false;
    }
    let re = /^\d{3}[-]{1}\d{8}/;
    if (re.test(value)) {
      return true;
    } else {
      return false;
    }
  }

  check_if_is_tc_number(value: any) {
    if (!value || value == '') {
      return true;
    }
    if (value.length != 11) {
      return false;
    }
    if (value != value.toUpperCase()) {
      return false;
    }
    let re = /^[A-Z]{4}\d{7}/;
    if (re.test(value)) {
      let sum = 0;
      for (let i = 0; i < 10; i++) {
        let n = value.substr(i, 1);
        if (i < 4) {
          n = '0123456789A?BCDEFGHIJK?LMNOPQRSTU?VWXYZ'.indexOf(value.substr(i, 1));
        }
        n *= Math.pow(2, i);
        sum += n;
      }
      if (value.substr(0, 4) == 'HLCU') {
        sum -= 2;
      }
      sum %= 11;
      sum %= 10;
      return sum == value.substr(10);
    } else {
      return false;
    }
  }


  check_if_is_siret_number(siret: any) {
    if (!siret || siret == '') {
      return true;
    }
    if (siret.length != 14) {
      return false;
    }
    let parity: number = siret.length % 2;
    let sum: number = 0;
    let value: number;
    for (let i = siret.length - 1; i >= 0; i--) {
      value = parseInt(siret.substring(i, i + 1));
      if (i % 2 == parity) {
        value = value * 2;
        if (value > 9) {
          value = value - 9;
        }
      }
      sum = sum + value;
    }
    return this.checkLuhn(siret);
  }

  checkLuhn(identifier: string): boolean {
    let result: boolean = false;
    let parity: number = identifier.length % 2;
    let sum: number = 0;
    let value: number;
    for (let i = identifier.length - 1; i >= 0; i--) {
      value = parseInt(identifier.substring(i, i + 1));
      if (i % 2 == parity) {
        value = value * 2;
        if (value > 9) {
          value = value - 9;
        }
      }
      sum = sum + value;
    }
    return ((sum % 10) == 0);
  }

}
